export default {
	/**
	 * 时间戳转日期格式
	 * @param {Object} timeStamp
	 */
	timeStampTurnTime(timeStamp) {
	    if (timeStamp != undefined && timeStamp != "" && timeStamp > 0) {
	        var date = new Date()
	        date.setTime(timeStamp * 1000)
	        var y = date.getFullYear()
	        var m = date.getMonth() + 1
	        m = m < 10 ? "0" + m : m
	        var d = date.getDate()
	        d = d < 10 ? "0" + d : d
	        var h = date.getHours()
	        h = h < 10 ? "0" + h : h
	        var minute = date.getMinutes()
	        var second = date.getSeconds()
	        minute = minute < 10 ? "0" + minute : minute
	        second = second < 10 ? "0" + second : second
	        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second
	    } else {
	        return ""
	    }
	},
	/**
	 * 获取某天日期
	 * @param {Object} day
	 */
	getDay: function(day) {
	    var today = new Date()
	    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
	    today.setTime(targetday_milliseconds)
	
	    const doHandleMonth = function(month) {
	        var m = month
	        if (month.toString().length == 1) {
	            m = "0" + month
	        }
	        return m
	    }
	
	    var tYear = today.getFullYear()
	    var tMonth = today.getMonth()
	    var tDate = today.getDate()
	    var tWeek = today.getDay()
	    var time = parseInt(today.getTime() / 1000)
	    tMonth = doHandleMonth(tMonth + 1)
	    tDate = doHandleMonth(tDate)
	
	    const week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
	    return {
	        t: time,
	        y: tYear,
	        m: tMonth,
	        d: tDate,
	        w: week[tWeek]
	    }
	},
	handlerDateDurationCurrent (time) {
	      let d1 = new Date(time)
	      let d2 = new Date()
	
	      let cha = Math.abs(d2.getTime() - d1.getTime())
	      let days = parseInt(cha / (24 * 60 * 60 * 1000))
	      let hours = parseInt(cha % (24 * 60 * 60 * 1000) / (60 * 60 * 1000))
	      let mins =  parseInt(cha % (60 * 60 * 1000) / (60 * 1000))
	      return {
	          d: days,
	          h: hours,
	          m: mins,
	      }
	    }
}